import React, {Component} from "react";
import {Link} from "react-router-dom";

import Bounce from "react-reveal/Bounce";

import Flash from "react-reveal/Flash";

class SureBuilt2026ConferenceInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        document.getElementById("header").scrollIntoView();
    }

    render() {
        let image_margin = "20px 0 0 0";
        let marginTop = "5%";

        if (window.innerWidth < 850) {
            image_margin = "-40px 0px 0px 0px";
            marginTop = "20%";
        }

        return (
            <div style={{ marginTop: "80px" }}>
                <section class="call-to-action-box no-padding">
                    <div class="container" style={{ marginBottom: "20px" }}>
                        <div class="action-style-box">
                            <h2 class="column-title" style={{ color: "black", textAlign: "center" }}>
                                Conference Information - SURE-Built 2026
                            </h2>
                        </div>
                    </div>
                </section>

                <Bounce right fraction={0.01}>
                    <section id="main-container" class="main-container">
                        <div class="container" style={{marginTop: "-50px"}}>
                            <div className="row">


                                <div className="col-lg-12 mt-5 mt-lg-0">
                                    <div
                                        style={{
                                        margin: image_margin,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        }}
                                    >
                                        <img
                                            src="images/sure-built-2026-logo2.png"
                                            alt="SureBuilt 2026"
                                            style={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>


                            </div>
                            <div class="row" style={{marginTop: marginTop}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Venue Information </h3>
                                    </Bounce>

                                    <p>
                                        <span
                                            style={{color: "red"}}>School of Tourism and Hospitality, University of Johannesburg, South Africa</span>
                                    </p>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Conference Fee </h3>
                                    </Bounce>
                                    <span style={{color: "red"}}>Free-To-Attend Conference – No Participation Fee</span><br/>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Organising committee </h3>
                                    </Bounce>

                                    <p>Prof. C. Aigbavboa, RSA – Conference Chair</p>
                                    <p>Prof. B. Awuzie, RSA – Conference Co-Chair</p>
                                    <p>Prof. D. Aghimien, RSA</p>
                                    <p>Prof. A. Oke, NIG</p>
                                    <p>Prof. T. Omotayo, UK</p>
                                    <p>Prof. L. Aghimien, RSA</p>
                                    <p>Dr. N. Ngcobo, RSA</p>
                                    <p>Dr. P. Tunji-Olayeni, NIG</p>
                                    <p>Dr. O. Akinradewo, RSA</p>
                                    <p>Dr. I.B. John, NIG</p>
                                    <p>Dr. G. Mollo, RSA</p>
                                    <p>Dr. N. Qumbisa, RSA</p>
                                    <p>Dr. A. Moghayedi, UK</p>
                                    <p>Dr. S. Belayutham, MALAYSIA</p>
                                    <p>Dr. S. Ofori Ametepey, GHA</p>
                                    <p>Dr. E. Kissi, GHA</p>
                                    <p>Prof. S. Adekunle, LIB</p>
                                    <p>Dr. M. Ikuabe, RSA</p>
                                    <p>Prof. O. Oguntona, RSA</p>

                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Conference Aims</h3>
                                    </Bounce>
                                    <ul>
                                        <li>
                                        To bring together interdisciplinary experts to explore and develop strategies for integrating Generative AI (GenAI) into sustainable knowledge creation and built environment development.
                                        </li>

                                        <li>
                                        To critically examine the role of epistemology in the GenAI era, particularly how knowledge is created, validated, and shared within the built environment in developing countries.
                                        </li>

                                        <li>
                                        To foster innovation through the application of emerging technologies such as GenAI in advancing sustainable design methodologies and predictive analytics.
                                        </li>

                                        <li>
                                        To promote interdisciplinary collaboration among professionals including architects, engineers, urban planners, environmental scientists, and policymakers.
                                        </li>

                                        <li>
                                        To support sustainable development in developing countries by bridging traditional knowledge systems with modern technological advancements.
                                        </li>

                                        <li>
                                        To ensure inclusivity and accessibility by maintaining a free-to-attend model that removes financial barriers to participation.
                                        </li>

                                        <li>
                                        To reshape the academic and research landscape by prioritizing equity, accessibility, and actionable impact in global scholarship.
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">ORGANISERS & CONFERENCE CHAIRPERSONS</h3>
                                    </Bounce>
                                    Professor Clinton Aigbavboa<br/>
                                    DSI/ NRF Research Chair (Interim) – Sustainable Construction Management and
                                    Leadership in the Built Environment, Faculty of Engineering and the Built
                                    Environment, University of Johannesburg, South Africa caigbavboa@uj.ac.za<br/>
                                    caigbavboa@uj.ac.za
                                    <p></p>
                                    Professor Bankole Awuzie<br/>
                                    Department of Construction Management and Quantity Surveying, University of
                                    Johannesburg, South Africa
                                    <br/>boawuzie@uj.ac.za
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Keynote Speakers</h3>
                                    </Bounce>
                                    <span style={{color: "red"}}>To be announced</span><br/>
                                </div>
                            </div>

                            <div className="row" style={{ marginTop: "2%" }}>
                                <div className="col-lg-12">
                                    <Bounce left>
                                        <h3 className="column-title">Endorsements</h3>
                                    </Bounce>
                            
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            justifyContent: "start",
                                            alignItems: "center",
                                            gap: "20px",
                                            marginTop: "20px",
                                        }}
                                    >
                                        <img
                                            src="images/ciob.png"
                                            alt="CIOB"
                                            style={{
                                            maxWidth: "200px",
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            }}
                                        />

                                        <img
                                            src="images/cidb.png"
                                            alt="CIDB"
                                            style={{
                                            maxWidth: "200px",
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row" style={{marginTop: "2%"}}>
                                <div class="col-lg-12">
                                    <Bounce left>
                                        <h3 class="column-title">Contact</h3>
                                    </Bounce>

                                    For more information or any queries send an email to:<span
                                    style={{color: "red"}}> surebuiltseries@gmail.com</span>
                                </div>
                            </div>


                        </div>
                    </section>
                </Bounce>

                <section class="call-to-action-box no-padding">
                    <div class="container" style={{marginBottom: "20px"}}>
                        <div class="action-style-box">
                            <div class="row align-items-center">
                            <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference">
                                                {" "}
                                                <a class="btn btn-dark">Conference Overview</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference-submissions">
                                                {" "}
                                                <a class="btn btn-dark">Conference Submissions</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/">
                                                {" "}
                                                <a class="btn btn-dark">Back to CR Centre</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default SureBuilt2026ConferenceInformation